import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Box, Container, Stack } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import { useSites } from "@shared/hooks/SiteHook";
import useGlobalStore from "@shared/store/GlobalStore";
import LinkEditor from "@administration/components/editor/LinkEditor";
import { useHomePageLocation } from "@administration/hooks/PageHook";
import Navigation from "./Navigation/Navigation";
const Header = ({ children }) => {
    const { currentSite: site } = useSites();
    const { settings: siteSettings } = site || {};
    const { logoHeader = null } = siteSettings || {};
    const { isBo } = useGlobalStore((state) => ({ isBo: state.isBo }));
    const { homePage } = useHomePageLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const handleScroll = useCallback(() => {
        setIsScrolled(window.scrollY > 0);
    }, []);
    useEffect(() => {
        if (isBo)
            return;
        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isBo, handleScroll]);
    return (_jsxs(Box, { component: "header", "data-dark": !isScrolled || undefined, sx: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: isScrolled ? "background.paper" : "background.header",
            transition: "background-color 0.2s ease",
            height: { xs: "72px", md: "88px" },
            zIndex: 10,
        }, children: [_jsx(Box, { component: "a", href: "#main-content", sx: {
                    position: "absolute",
                    top: 8,
                    left: 16,
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                    textDecoration: "none",
                    transform: "translateY(-200%)",
                    transition: "transform 0.2s ease",
                    zIndex: 20,
                    "&:focus, &:focus-visible": {
                        transform: "translateY(0)",
                        outline: "2px solid",
                        outlineColor: "primary.contrastText",
                        outlineOffset: 2,
                    },
                }, children: "Aller au contenu principal" }), _jsx(Container, { sx: {
                    maxWidth: "1528px !important",
                    pl: "24px !important",
                    pr: { md: "8px !important", lg: "24px !important" },
                }, children: _jsxs(Stack, { component: "nav", direction: "row", sx: { alignItems: "center", justifyContent: "space-between", py: 1 }, children: [_jsx(Box, { sx: {
                                height: { xs: "56px", md: "72px" },
                                alignItems: "center",
                                display: "flex",
                                "& img": {
                                    width: { xs: "160px", md: "190px" },
                                    maxHeight: "100%",
                                },
                            }, children: isBo ? (_jsx(LinkEditor, { page: homePage, "aria-label": "Lien vers la page d'accueil", children: logoHeader || (_jsx("img", { alt: "", src: isScrolled
                                        ? "/logo-docaposte-blue.svg"
                                        : "/logo-docaposte-white.svg" })) })) : (_jsx(Link, { url: "/", "aria-label": "Lien vers la page d'accueil", sx: { display: "flex", alignItems: "center" }, children: logoHeader || (_jsx("img", { alt: "", src: isScrolled
                                        ? "/logo-docaposte-blue.svg"
                                        : "/logo-docaposte-white.svg" })) })) }), _jsx(Navigation, {})] }) }), children] }));
};
export default Header;
